import React from 'react';

import { Grid, Select } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

import useIntegrationSelectProps from './useIntegrationSelectProps';

export default function IntegrationSelect() {
  const { integrationNameSelectProps, revisionSelectProps } = useIntegrationSelectProps();

  const { disabledMessage: integrationsDisabledMessage, ...restIntegrationNameSelectProps } =
    integrationNameSelectProps;
  const { disabledMessage: revisionsDisabledMessage, ...restRevisionSelectProps } = revisionSelectProps;

  return (
    <Grid item container gap={1} alignItems="center">
      <Grid item flexGrow={1}>
        <WithTooltip show={Boolean(integrationsDisabledMessage)} container="div" title={integrationsDisabledMessage}>
          <Select {...restIntegrationNameSelectProps} />
        </WithTooltip>
      </Grid>

      <Grid item xs={3}>
        <WithTooltip show={Boolean(revisionsDisabledMessage)} container="div" title={revisionsDisabledMessage}>
          <Select {...restRevisionSelectProps} />
        </WithTooltip>
      </Grid>
    </Grid>
  );
}
